import React from "react";
import { useLanguage } from "../Translations/LenguageContext";

const DepLearn = () => {
    const { t } = useLanguage();

    return (
        <div className="brain_cont fade-in">
            <h3>{t.cognitiveMemory.title}</h3>
            <p className="brain_card_desc">{t.cognitiveMemory.desc}</p>
        </div>
    );
}

export default DepLearn;
